// removed by extract-text-webpack-plugin
module.exports = {"BookTestDrive":"BookTestDrive__BookTestDrive___as7OB","BookTestDriveForm":"BookTestDrive__BookTestDriveForm___3sCbZ","BookTestDriveFormText":"BookTestDrive__BookTestDriveFormText___267RK","requiredStar":"BookTestDrive__requiredStar___3j0sg"};


//////////////////
// WEBPACK FOOTER
// ./src/AtomicContainers/BookTestDrive/BookTestDrive.less
// module id = 1123
// module chunks = 0 1